import React, { useEffect, useState, useCallback } from "react";
import { API_BASE } from "../../config";
import Loader from "./Loader";

function MessageInbox({ token }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState("");

  const authHeader = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const fetchMessages = useCallback(async (pageNum) => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/contact?page=${pageNum}&limit=20`, { headers: authHeader });
      if (!res.ok) throw new Error("Failed to load messages");
      const json = await res.json();
      setMessages(json.data || []);
      setTotalPages(json.totalPages || 1);
    } catch (err) {
      setError(err.message || "Failed to load messages");
    }
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchMessages(page); }, [page, fetchMessages]);

  const markRead = async (id) => {
    try {
      const res = await fetch(`${API_BASE}/contact/${id}/read`, { method: "PUT", headers: authHeader });
      if (!res.ok) throw new Error("Failed to mark as read");
      setMessages(messages.map((m) => (m._id === id ? { ...m, read: true } : m)));
    } catch (err) {
      setError(err.message || "Failed to mark as read");
    }
  };

  return (
    <div className="inbox">
      {loading && <Loader text="Loading messages..." />}
      {error && <p style={{ color: "#b02a2a", fontSize: "13px" }}>{error}</p>}
      {messages.length === 0 && !loading && !error && <p>No messages yet.</p>}
      {messages.map((m) => (
        <div key={m._id} className={`inbox-item ${m.read ? "" : "unread"}`}>
          <div className="inbox-header">
            <strong>{m.name}</strong>
            <span>{m.email}</span>
            <span className="inbox-date">{new Date(m.createdAt).toLocaleDateString()}</span>
          </div>
          <p>{m.message}</p>
          {!m.read && (
            <button className="btn-secondary" onClick={() => markRead(m._id)}>
              Mark as read
            </button>
          )}
        </div>
      ))}
      {totalPages > 1 && (
        <div className="inbox-pagination">
          <button className="btn-secondary" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button className="btn-secondary" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </div>
  );
}

export default MessageInbox;
